export const FLOWER_SIZES = [
  { key: "1g", label: "1G", grams: "1 gram" },
  { key: "8th", label: "8th", grams: "4G" },
  { key: "quarter", label: "Quarter", grams: "8G" },
  { key: "half", label: "Half OZ", grams: "16G" },
  { key: "oz", label: "OZ", grams: "28 grams" },
];

export const PREROLL_OPTIONS = [
  { key: "preroll_1g", label: "1G Preroll", grams: "1 preroll" },
  { key: "preroll_2pk", label: "2-Pack Preroll", grams: "2 prerolls" },
  { key: "preroll_3pk", label: "3-Pack Preroll", grams: "3 prerolls" },
];

// Every purchasable tier of a flower product (weights + prerolls of the same strain)
export const ALL_FLOWER_TIERS = [...FLOWER_SIZES, ...PREROLL_OPTIONS];

export const GROW_METHODS = ["Light Dep", "Indoor Living Soil", "Outdoor"];

export const SIZE_NOTE =
  "Our sizing: 8th = 4G · Quarter = 8G · Half OZ = 16G. 1G and OZ are standard sizes.";

export function flowerPriceRange(product) {
  const prices = Object.values(product?.prices || {}).filter((v) => v > 0);
  if (!prices.length) return null;
  return { min: Math.min(...prices), max: Math.max(...prices) };
}

export function isFlower(product) {
  return product?.category === "flower";
}

export const STRAIN_TYPES = ["indica", "sativa", "hybrid"];

export const STRAIN_GLOW = {
  indica: "glow-indica",
  sativa: "glow-sativa",
  hybrid: "glow-hybrid",
};

export function glowClass(strain) {
  return STRAIN_GLOW[strain] || "border-white/10";
}

export const CATEGORIES = [
  { key: "flower", label: "Flower" },
  { key: "blunt", label: "Blunts" },
  { key: "concentrate", label: "Concentrates" },
];
